import {createFeatureSelector, createSelector} from "@ngrx/store";
import {MeasurementState} from "./measurement.reducer";

const getSharedState = createFeatureSelector<MeasurementState>('measurements');
export const getUserMeasurements = createSelector(getSharedState, (state: MeasurementState) => state?.measurements);
